'use strict';

namespace Core {

    class ConfidenceMessages {
        private showNortonLogo: boolean = true;
        private messages: string[] = [];
        private messagesResolved: string[];
        private atolProtected: string;
        private showAtolLogo: boolean = false;
        private commissionOfAviation: string;
        private showCommissionOfAviation: boolean = false;
        private flexiblePayments: string;
        private debitMessageType: string;

        public showDebitIcon: boolean;
        public debitMessage: string;

        constructor(resourceService: Core.ResourceService) {
            if (this.flexiblePayments === 'true') {
                this.messages.unshift('USPFLEXIBLEPAYMENT');
            }
            if (this.atolProtected === 'true') {
                this.showAtolLogo = true;
                this.messages.unshift('ATOLPROTECTEDHOLIDAY');
            }

            if (this.commissionOfAviation === 'true') {
                this.showCommissionOfAviation = true;
                this.messages.unshift('COMMISSIONOFAVIATIONMESSAGE');
            }
            this.messagesResolved = this.messages.map(s => resourceService.get(s));
        }
    }

    angular
        .module('core')
        .component('confidenceMessages', {
            bindings: {
                atolProtected: '@',
                commissionOfAviation: '@',
                flexiblePayments: '@',
                debitMessageType: '@'
            },
            controller: ConfidenceMessages,
            template: `
                <div class="security-badge">
                    <div class="logo-list">
                        <span class="logo-list__item" ng-if="$ctrl.showNortonLogo">
                            <sc-svg-inline 
                                name="norton-logo" 
                                svg-width="90" 
                                svg-height="41">  
                            </sc-svg-inline>
                        </span>
                        <span class="logo-list__item" ng-if="$ctrl.showAtolLogo">
                            <sc-svg-inline 
                                name="atol-logo" 
                                svg-width="40" 
                                svg-height="41">  
                            </sc-svg-inline>
                        </span>
                        <span class="logo-list__item" ng-if="$ctrl.showCommissionOfAviation">
                            <sc-svg-inline 
                                name="commission-for-aviation-regulation" 
                                svg-width="50" 
                                svg-height="41">  
                            </sc-svg-inline>
                        </span>
                    </div>
                    <div class="confidence-text">
                        <ul>
                            <li ng-repeat="message in $ctrl.messagesResolved">{{message}}</li>
                        </ul>
                    </div>
                    <div class="debit-message" ng-if="$ctrl.showDebitIcon">
                        <i class="icon-payment"></i>
                        {{$ctrl.debitMessage}}
                    </div>
                </div>
            `
        });
}
